<!-- Modal Header -->
<div class="modal-header bg-head py-2 d-flex justify-content-between align-items-center">
  <h6 class="modal-title mb-0">Select Features Applicable to the Course</h6>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<!-- Modal Body -->
<div class="modal-body p-0">
  <div class="px-4 pt-3">
    <table class="table table-sm align-middle text-center">
      <thead class="table-light">
        <tr>
          <th class="fw-medium border-0" style="width: 5%;">✔</th>
          <th class="fw-medium border-0 text-start">Feature Description</th>
          <th class="fw-medium border-0" style="width: 15%;">New Feature?</th>
          <th class="fw-medium border-0" style="width: 10%;">Display Order</th>
        </tr>
      </thead>
      <!-- Selected Features: Draggable -->
      <tbody cdkDropList [cdkDropListData]="selectedFeatures" (cdkDropListDropped)="drop($event)">
        <tr *ngFor="let feature of selectedFeatures" cdkDrag class="border-bottom-0">
          <td class="border-bottom-0">
            <input type="checkbox"   [checked]="feature.isSelected"  (change)="toggleFeatureSelection(feature)" />
          </td>
          <td class="border-bottom-0 text-start">
            <div class="custom-input-path text-wrap">{{ feature.Description }}</div>
          </td>
          <td class="border-bottom-0">
            <input type="checkbox" [(ngModel)]="feature.isNew" [ngModelOptions]="{standalone: true}" />
          </td>
          <td class="border-bottom-0">
            <input type="number" class="form-control form-control-sm text-center" style="max-width: 80px;" [(ngModel)]="feature.Display_Order" [ngModelOptions]="{standalone: true}" />
          </td>
        </tr>
      </tbody>
      <!-- Unselected Features: Static -->
      <tbody>
        <tr *ngFor="let feature of unselectedFeatures" class="border-bottom-0">
          <td class="border-bottom-0">
            <input type="checkbox"   [checked]="feature.isSelected"  (change)="toggleFeatureSelection(feature)" />
          </td>
          <td class="border-bottom-0 text-start">
            <div class="custom-input-path text-wrap">{{ feature.Description }}</div>
          </td>
          <td class="border-bottom-0">
            <input type="checkbox" [(ngModel)]="feature.isNew" [ngModelOptions]="{standalone: true}" />
          </td>
          <td class="border-bottom-0">
            <input type="number" [disabled]="true" class="form-control form-control-sm text-center" style="max-width: 80px;" [(ngModel)]="feature.Display_Order" [ngModelOptions]="{standalone: true}" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Modal Footer -->
<div class="modal-footer d-flex justify-content-end gap-2">
  <button type="button" class="btn btn-sm bl-btn px-3" (click)="save()">Save</button>
  <button type="button" class="btn btn-sm bg-light border px-3" (click)="activeModal.dismiss()">Cancel</button>
</div>
